module.exports = __webpack_public_path__ + "static/media/fortlev-logo.8bbc07d0.png";